"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useSidebarState", {
  enumerable: true,
  get: function get() {
    return _Dialog.useDialogState;
  }
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _css2 = _interopRequireDefault(require("@styled-system/css"));

var _Dialog = require("reakit/Dialog");

var _styled2 = require("../../../utils/styled");

var _system = _interopRequireWildcard(require("../../../utils/system"));

var _SidebarContext = _interopRequireDefault(require("../SidebarContext/SidebarContext"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var placements = {
  left: 'left',
  right: 'right'
};
var breakpoints = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl'
};
var propTypes = {
  /**
   * Native html attribute for aria-label.
   */
  ariaLabel: _propTypes.string.isRequired,

  /**
   * The content of the sidebar.
   */
  children: _propTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the components.
   */
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    backdrop: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  }),

  /**
   * Breakpoint to hide sidebar and controller with state
   */
  expand: (0, _propTypes.oneOf)(Object.values(breakpoints)),

  /**
   * Placement to display sidebar
   */
  placement: (0, _propTypes.oneOf)(Object.values(placements)),

  /**
   * State of the sidebar created with `useSidebarState` hook.
   */
  state: (0, _propTypes.shape)({}).isRequired
};
var defaultProps = {
  classes: {
    backdrop: null,
    root: null
  },
  expand: breakpoints.lg,
  placement: placements.left
};
var Sidebar = (0, _system["default"])('aside')({
  label: 'Sidebar'
}, function (_ref) {
  var _css;

  var placement = _ref.placement;
  return (0, _css2["default"])((_css = {}, _defineProperty(_css, "".concat(placement), 0), _defineProperty(_css, "bg", 'white'), _defineProperty(_css, "border", '1px'), _defineProperty(_css, "borderColor", 'gray.200'), _defineProperty(_css, "bottom", 0), _defineProperty(_css, "boxShadow", 'md'), _defineProperty(_css, "boxSizing", 'border-box'), _defineProperty(_css, "overflowY", 'auto'), _defineProperty(_css, "position", 'fixed'), _defineProperty(_css, "top", 0), _defineProperty(_css, "width", 'sidebar'), _defineProperty(_css, "zIndex", 'banner'), _css));
}, function (_ref2) {
  var animated = _ref2.animated,
      isStatic = _ref2.isStatic,
      placement = _ref2.placement;
  return animated && !isStatic && {
    opacity: 0,
    transition: 'transform 250ms ease',
    transform: "translateX(".concat(placement === placements.left ? '-100%' : '100%', ")"),
    '&[data-enter]': {
      transform: 'translateX(0)',
      opacity: 1
    }
  };
}, (0, _system.classesStyles)('root'));
var SidebarBackdrop = ( /*#__PURE__*/0, _base["default"])(_Dialog.DialogBackdrop, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['classes'].includes(prop);
  },
  target: "elr8tx50"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['classes'].includes(prop);
  },
  target: "elr8tx50",
  label: "SidebarBackdrop"
})((0, _css2["default"])({
  zIndex: 'overlay',
  position: 'fixed',
  bg: 'blackAlpha.600',
  boxSizing: 'border-box',
  bottom: 0,
  right: 0,
  left: 0,
  top: 0
}), function (_ref3) {
  var animated = _ref3.animated;
  return animated && {
    opacity: 0,
    transition: 'opacity 250ms ease',
    '&[data-enter]': {
      opacity: 1
    }
  };
}, (0, _system.classesStyles)('backdrop'));
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref4, ref) {
  var state = _ref4.state,
      ariaLabel = _ref4.ariaLabel,
      _children = _ref4.children,
      expand = _ref4.expand,
      props = _objectWithoutProperties(_ref4, ["state", "ariaLabel", "children", "expand"]);

  var isStatic = (0, _styled2.useUp)(expand);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidebarContext["default"].Provider, {
    value: state,
    children: isStatic ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Sidebar, _objectSpread(_objectSpread({
      ref: ref,
      isStatic: isStatic
    }, props), {}, {
      children: _children
    })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(SidebarBackdrop, _objectSpread(_objectSpread({}, state), {}, {
      classes: props.classes,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.Dialog, _objectSpread(_objectSpread(_objectSpread({
        ref: ref
      }, props), state), {}, {
        "aria-label": ariaLabel,
        children: function children(dialogProps) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(Sidebar, _objectSpread(_objectSpread({
            isStatic: isStatic,
            animated: state.animated
          }, dialogProps), {}, {
            children: _children
          }));
        }
      }))
    }))
  });
});
Component.displayName = 'Sidebar';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
Component.Disclosure = _Dialog.DialogDisclosure;
Component.Backdrop = _Dialog.DialogBackdrop;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=Sidebar.js.map